import React, { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import AddToHomeScreenIcon from '@mui/icons-material/AddToHomeScreen';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

const InstallPWAButton = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [canInstall, setCanInstall] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [isIOS, setIsIOS] = useState(false);

  useEffect(() => {
    // Detect if running as standalone
    const isInStandaloneMode =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setIsStandalone(isInStandaloneMode);

    // iOS detection
    const userAgent = window.navigator.userAgent;
    const isIosDevice = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
    setIsIOS(isIosDevice);

    const beforeInstallHandler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setCanInstall(true);
    };

    window.addEventListener('beforeinstallprompt', beforeInstallHandler);

    return () => {
      window.removeEventListener('beforeinstallprompt', beforeInstallHandler);
    };
  }, []);

  const handleInstallClick = () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === 'accepted') {
        console.log('✅ PWA install accepted');
      } else {
        console.log('❌ PWA install dismissed');
      }
      setDeferredPrompt(null);
      setCanInstall(false);
    });
  };

  // Don't show anything if already installed
  if (isStandalone) return null;

  return (
    <>
      {isIOS && (
        <Box sx={{ p: 2, backgroundColor: '#fff3cd', borderRadius: 2, mt: 2 }}>
          <Typography variant="body2" color="textPrimary">
            To install this app on iOS, tap <strong>Share</strong> and then <strong>"Add to Home Screen"</strong>.
          </Typography>
        </Box>
      )}

      {!isIOS && canInstall && (
        <Button
          variant="contained"
          color="primary"
          onClick={handleInstallClick}
          startIcon={<AddToHomeScreenIcon />}
          sx={{ zIndex: 9999, mt: 2 }}
        >
          Install App
        </Button>
      )}
    </>
  );
};

export default InstallPWAButton;
